var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 45a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 51h15a1 1 0 0 0 0-2h-15a1 1 0 0 0 0 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7 55h15a1 1 0 0 0 0-2h-15a1 1 0 0 0 0 2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 23,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 23,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.45 33.11-6-3a1 1 0 0 0 -1.45.89v6a1 1 0 0 0 .47.85 1 1 0 0 0 .53.15 1 1 0 0 0 .45-.11l6-3a1 1 0 0 0 0-1.78zm-5.45 2.27v-2.76l2.76 1.38z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15 43a9 9 0 0 0 4.57-1.25 1 1 0 0 0 -1-1.73 7 7 0 1 1 2.43-2.47 1 1 0 0 0 1.73 1 9 9 0 1 0 -7.73 4.45z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25 18h-20a3 3 0 0 0 -3 3v20a1 1 0 0 0 2 0v-20a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v38a1 1 0 0 1 -1 1h-20a1 1 0 0 1 -1-1v-14a1 1 0 0 0 -2 0v14a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-38a3 3 0 0 0 -3-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.45 24.11-6-3a1 1 0 0 0 -1.45.89v6a1 1 0 0 0 .47.85 1 1 0 0 0 .53.15 1 1 0 0 0 .45-.11l6-3a1 1 0 0 0 0-1.78zm-5.45 2.27v-2.76l2.76 1.38z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m37 39h16a1 1 0 0 0 0-2h-16a1 1 0 0 0 0 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m30 42a1 1 0 0 0 1 1h22a1 1 0 0 0 0-2h-22a1 1 0 0 0 -1 1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m58 12h-46a4 4 0 0 0 -3.76 2.67 1 1 0 0 0 1.89.66 2 2 0 0 1 1.87-1.33h46a2 2 0 0 1 2 2v30a2 2 0 0 1 -2 2h-27a1 1 0 0 0 0 2h27a4 4 0 0 0 4-4v-30a4 4 0 0 0 -4-4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m51.38 29.92a1 1 0 0 0 1.37-.35 9 9 0 1 0 -3.18 3.18 1 1 0 0 0 -1-1.73 7 7 0 1 1 2.43-2.47 1 1 0 0 0 .38 1.37z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.57f9e0c3.svg";
export { ForwardRef as ReactComponent };